import SseHub from './SseHub.js';

// Narración del reproceso en tanda (reclasificar items o sincronizar expedientes).
// Singleton de módulo, como los demás canales: la tanda tarda minutos y quien la lanzó suele
// irse a otra pantalla, así que el aviso de fin tiene que llegar igualmente.

const subscribers = [];
let enganchado = false;
const CANAL = 'reproceso-masivo';
let f7ref = null;
let ultimoResumen = null;

function notify(payload) {
    subscribers.slice().forEach(function (cb) {
        try { cb(payload); } catch (err) { console.error('ReprocesoMasivoEvents subscriber threw', err); }
    });
}

function toastGlobal(texto) {
    try {
        if (f7ref && f7ref.toast) {
            f7ref.toast.create({ text: texto, closeTimeout: 6000, closeButton: true }).open();
        }
    } catch (e) {}
}

function onEvento(evento) {
    // El hub entrega el payload ya deserializado; se admite cadena por si acaso.
    let payload = evento;
    if (typeof evento === 'string') {
        try { payload = JSON.parse(evento); } catch (err) { payload = evento; }
    }
    if (payload && (payload.estado === 'fin' || payload.estado === 'cancelado')) {
        ultimoResumen = payload;
        toastGlobal((payload.estado === 'cancelado' ? '⏹️ Reproceso cancelado: ' : '✅ Reproceso terminado: ')
            + payload.procesados + ' de ' + payload.total + ' · ' + payload.cambiados + ' cambiaron'
            + (payload.errores ? ' · ' + payload.errores + ' con error' : ''));
    }
    notify(payload);
}

function ensureConnected() {
    if (enganchado) return;
    enganchado = true;
    SseHub.subscribe(CANAL, onEvento);
}

export default {
    subscribe(callback, f7) {
        if (f7) f7ref = f7;
        if (typeof callback === 'function' && subscribers.indexOf(callback) < 0) {
            subscribers.push(callback);
        }
        ensureConnected();
    },
    unsubscribe(callback) {
        const i = subscribers.indexOf(callback);
        if (i >= 0) subscribers.splice(i, 1);
    },
    /** Último resumen recibido en esta sesión de navegador (null si no hubo). */
    ultimoResumen() {
        return ultimoResumen;
    }
};
